// API
import { useApiSWRReference } from '@/hooks/useApiSWR'

import { MultiSelect } from '@mantine/core'

export default function ProductCollectionsSelect({ label, ...props }) {
    const { data: collections } = useApiSWRReference('/product-collections')

    const data =
        collections?.map((collection) => ({
            value: String(collection.id),
            label: collection.name_fr,
        })) ?? []

    return (
        <MultiSelect
            data={data}
            label={label}
            placeholder="Sélectionnez une ou plusieurs collections"
            withinPortal={true}
            {...props}
        />
    )
}
